'use client'

import { Image } from '@vinted/web-ui'

import { getFingerprint } from '@marketplace-web/session-management/audit-util'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import {
  landingPageEvent,
  HoVIntroductionModel,
  HoVLandingPageEvent,
} from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

type Props = {
  data: HoVIntroductionModel
}

export const HoVIntroduction = ({
  data: { description, ctaText, ctaUrl, videoUrl, imageUrl, image2xUrl, title },
}: Props) => {
  const { track } = useTracking()
  const handleOnCtaClick = async () =>
    track(
      landingPageEvent({
        event: HoVLandingPageEvent.IntroductionCtaClick,
        targetDetails: ctaUrl,
        deviceId: await getFingerprint(),
      }),
    )

  return (
    <section className="hov__introduction-section" data-testid="introduction-section">
      <div className="hov__introduction-media-container">
        {videoUrl ? (
          <iframe
            src={videoUrl}
            className="hov__introduction-video-iframe"
            allow="clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            data-testid="new-again-intro_video"
            title={title}
          />
        ) : (
          <div className="hov__introduction-image">
            <Image
              src={imageUrl}
              scaling={Image.Scaling.Cover}
              testId="introduction-section-image"
              srcset={`${imageUrl} 1x, ${image2xUrl} 2x`}
            />
          </div>
        )}
      </div>

      <h2 className="hov__introduction-title">{title}</h2>

      <p className="hov__introduction-description">{description}</p>
      <a
        role="button"
        href={ctaUrl}
        className="hov__introduction-cta"
        data-testid="hov-introduction-cta"
        onClick={handleOnCtaClick}
      >
        {ctaText}
      </a>
    </section>
  )
}
